import React, {useState, useEffect} from 'react'
import {storage} from "../../firebase/firebase"
import { Card, Container, Button,  Accordion, Row, Col } from 'react-bootstrap';
import homeCss from './HomePage.css';
import axios from '../../axios-orders';
import Blog from '../../components/Blog/Blog';
import NewBook from '../../components/NewBook/NewBook';
import BookCard from '../../components/BookCard/BookCard';
import NewChapter from '../../components/NewChapter/NewChapter';
import NewHadith from '../../components/NewHadith/NewHadith';
import { useHistory, withRouter, useParams, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import { EditorState, ContentState, convertToRaw, convertFromHTML, convertFromRaw } from 'draft-js';
import {Editor} from "react-draft-wysiwyg";
import { convertToHTML } from 'draft-convert';
import DOMPurify from 'dompurify';
import Modal from '../../components/UI/Modal/Modal';

//add import for storage 
const blogmain = (props) => {
    const history = useHistory();
    const location = useLocation();
    //const id = location.state.id;
    const id = 'test-id';
    //const table = location.state.table;
    const table = 'table-test';
    const [divContent, setDivContent] = useState('');
    const [dataObject, setDataObject] = useState({});
    const [blogs, setBlogs] = useState({});
    const [blogKey, setBlogkey] = useState('');
    const [blogText, setBlogtext] = useState('');
    const [blogList,setBloglist] = useState([]);
    const [bookList,setBookList] = useState([]);
    const [title, setTitle] = useState('');
    const [status, setStatus] = useState(false);
    const [postEditorVisible, setPostEditorVisible] = useState(false)
    const [editPostData, setEditPostData] = useState(null)
    const [posts, setPosts] = useState(null)
    const [clicked, setClicked] = useState(false);
    const [alertMessage, setAlertmessage] = useState(null);

    const [editorState, setEditorState] = useState(
      () => EditorState.createEmpty(),
    );
    const [convertedContent, setConvertedContent] = useState(null);

    const handleStatusChange = (event) => {
      setStatus(event.target.value);    
    }

    const handleEditorChange = (state) => {
      setEditorState(state);
      convertContentToHTML();
    }

    const newBookDiv = (state) => {
      setDivContent(<NewBook cancelHandler={cancelHandler} saveBook={saveBook}/>);
    }


    const newHadithDiv = (state) => {
      setDivContent(<NewHadith/>);
    }

    const convertContentToHTML = () => {
      let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
      setConvertedContent(currentContentAsHTML);
    }
  
    const createMarkup = (html) => {
      return  {
        __html: DOMPurify.sanitize(html)
      }
    }

    const routeChange=(path)=> {
      //let path = `/PdfTable`;
      history.push(path);
      }
    
    const alertCancelHandler = () => {
      setClicked(false);
      delay(function(){
        window.location.reload(false);   
      }, 100 ); // end delay

    };
    
    useEffect(() => {
        (async () => {
          
            let jsonTable = 'pdfMetadata';
            if(table === 'book')
            {
                jsonTable = 'bookMetadata';
            }
            let url = 'https://abc1-ceaf0-default-rtdb.firebaseio.com/'+jsonTable+'/'+id+".json";
            axios.get(url)
          .then((response) => {
            const responseData = response.data;
            //alert("pdfMetadata:"+JSON.stringify(responseData));
            setDataObject(responseData);
            setTitle(responseData.title);
          })
          .catch(error => {
            console.log(error)
          })

          if (id && id.trim().length) {  
            const queryParams = '?"&orderBy="pdfId"&equalTo="' + id + '"';
            //alert(queryParams);
            axios.get( '/blogData.json' + queryParams)
                .then( res => {
                    const responseData = res.data;
                    //alert(JSON.stringify(responseData));

                    for (var key in responseData) {
                        setBlogkey(key);
                        if (responseData.hasOwnProperty(key)) {  
                            var obj = responseData[key];
                            var text = obj.blogText;
                            var email = obj.userEmail;
                            var status1 = obj.complete;
                            if(email === props.userEmail)
                            {
                                //alert("key:"+key+":text:"+text);
                                setBlogtext(text);
                                setStatus(status1);

                                //alert("before convertFromHTML:"+obj.blogText);
                                const blocksFromHTML = convertFromHTML(obj.blogText);
                                const state = ContentState.createFromBlockArray(
                                  blocksFromHTML.contentBlocks,
                                  blocksFromHTML.entityMap,
                                );
                                
                                //alert("blogdata.data"+blogdata.data);
                                // const [editorState, setEditorState] = useState(
                                //   () => EditorState.createWithContent(state),
                                // );
                                setEditorState(() => EditorState.createWithContent(state),);
 

                            }
                        }
                    }
                } )
                .catch( err => {
                } );
            }

              const queryParams1 = '?orderBy="pdfId"&equalTo="' + id + '"';
              //alert(queryParams1);
              axios.get( '/book.json')
                  .then( res => {
                    const responseData = res.data;

                    //Object.entries(responseData).map(([key, blog]) => (
                    //alert(":blog:"+JSON.stringify(responseData))
                    //));
                    var myArr = ["#90a4e5", "#bfbdbd", "#6ebb80","#e6b4b9"];
                    var myArr2 = ["#bfddf1","#e9ecef","#e9ecef","#e9ecef"];
                    var cnt = 0;
                    
                    let bookList1 = new Map([]);
                    for (let [key, value] of Object.entries(responseData)) {
                      var name = value['name'];
                      bookList1[key]=name;
                    }
                    setBookList(bookList1);
            

                    const blogList1 = Object.entries(responseData).map(([key, blog]) => {
                        var bcolor = myArr[cnt];
                        cnt++;
                        if(cnt > 4)
                        {
                          cnt=0;
                        }
                        return <a onClick={(event) => {routeChange("/ChapterList?id="+key)}}><BookCard
                          key={key}
                          bookname={blog.name}
                          author={blog.author}
                          bcolor={bcolor}
                        /></a>
                    });

                    setBloglist(blogList1);

                  } )
                  .catch( err => {
                  } );
                    



        })();
      }, []);
        
      const handleChange = e => {
        setBlogtext(e.target.value);
      }

      const cancelHandler = (event) => {
        event.preventDefault();
        setDivContent(null);
      }



    var delay = ( function() {
      var timer = 0;
      return function(callback, ms) {
          clearTimeout (timer);
          timer = setTimeout(callback, ms);
      };
    })();


    const saveBook = e => {
            e.preventDefault()
            var bname = document.getElementById('bname').value;
            var author = document.getElementById('author').value;

            const blogData = {
              userEmail:props.userEmail,
              userName:props.userName,
              name:bname,
              author:author,
            };

            axios.post( '/book.json?auth='+props.token, blogData)
                .then( response => {
                    //alert("successfully uploaded....");
                    setAlertmessage(
                      <div style={{textAlign:'left'}}>
                          Updated blog text
                      </div>
                    );  
                    setClicked(true);


            } )
            .catch( error => {
                    alert( "error:"+error ) ;
            } );
          }



    
    var delay = ( function() {
      var timer = 0;
      return function(callback, ms) {
          clearTimeout (timer);
          timer = setTimeout(callback, ms);
      };
    })();


      const handleFireBaseUpload = e => {
            e.preventDefault()
            // var blogText = document.getElementById('blogText').value;
            var blogText = editorState;
            var statusBoolean = false;
            if(status === 'true')
            {
              statusBoolean = true;
            }
            // const blogData = {
            // blogText: blogText,
            // userEmail:props.userEmail,
            // userName:props.userName,
            // pdfId:id,
            // title:title,
            // complete:statusBoolean,
            // };

            if(convertedContent === '<p></p>' || convertedContent === undefined || convertedContent === null || convertedContent === '')
            {
              //alert("Blog text is empty, please type in blog section before you hit submit")
              setAlertmessage(
                <div style={{textAlign:'left'}}>
                    Blog text is empty
                    <br></br><br></br>
                    Please type in blog section before you hit submit
                </div>
              );
              setClicked(true);
              return;
            }

            const blogData = {
              blogText: convertedContent,
              userEmail:props.userEmail,
              userName:props.userName,
              pdfId:id,
              title:title,
              complete:statusBoolean,
              };

              if(blogKey === undefined || blogKey === null || blogKey === '')
            {
                //alert("blogkey is null....:"+blogKey)
                //alert("editorData:"+convertedContent);

                //alert("blogText:"+blogText+":userEmail:"+emailId);

                axios.post( '/blogData.json?auth='+props.token, blogData )
                .then( response => {

                    setAlertmessage(
                      <div style={{textAlign:'left'}}>
                          Updated blog text
                      </div>
                    );
                    setClicked(true);
                  } )
                .catch( error => {
                    alert( "error:"+error ) ;
                } );

            }
            else
            {
                //alert("blogkey is .... NOT .... null....:"+blogKey)







                axios.put( '/blogData/'+blogKey+'/.json?auth='+props.token, blogData)
                .then( response => {
                    //alert("successfully uploaded....");
                    setAlertmessage(
                      <div style={{textAlign:'left'}}>
                          Updated blog text
                      </div>
                    );  
                    setClicked(true);


                } )
                .catch( error => {
                    alert( "error:"+error ) ;
                } );








            }
        }

    if(props.isAuthenticated)
    {          
    return (
        <div style={{overflow:'scroll', height:'100%', backgroundColor:'white', width:'100%'}}>
          <Modal show={clicked} modalClosed={alertCancelHandler}>
            {alertMessage}
          </Modal>
          <div style={{padding:'25px 25px 25px 25px'}}>
            <button className="btn btn-secondary px-4" onClick={newBookDiv} style={{fontSize:"15px",backgroundColor:'#0c1531'}} >Add Book</button>&nbsp;&nbsp;&nbsp;
          </div>


          <div>
            {divContent}
          </div>

          <br></br><br></br>
          <div className='panel panel-default align-items-center p-3 my-3' style={{width:'70%', height:'100%', overflow:'scroll'}}>
            <div className='align-items-center p-4 my-4 rounded shadow panel-heading' style={{ color:"black", alignItems:"center", alignContent:"center", justifyContent:"center", flexDirection: "row", display:'flex', width:"fit-content"}}>
                  {blogList}
            </div>
          </div>
        </div>
    );
    }
    else
    {
      return (
        <div style={{overflow:'scroll', height:'100%', backgroundColor:'white', width:'100%'}}>
        <hr style={{border: '10px solid #042a4a'}}></hr> <b><h3>Blogs on {title}</h3></b>
                {blogList}
                <br></br><br></br>
        </div>
      );
    }



}

const mapStateToProps = state => {
    return {
      isAuthenticated: state.auth.token !== null,
      token: state.auth.token,
      admin: state.auth.admin,
      userName: state.auth.userName,
      userEmail: state.auth.userEmail,
      org: state.auth.org,  
    };
  };
  
export default withRouter(
    connect(
      mapStateToProps,
    )(blogmain)
);
  



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.js